module.exports = __webpack_public_path__ + "static/media/hard-hat.67764a76.svg";